module.exports = __webpack_public_path__ + "./Carina2_fbf9efb2a948764488bd904f1f7a8311.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Carina2.png
// module id = 547
// module chunks = 0